import "./Layout.css";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var styles = {
    "layout": "mc7b5ceb67_layout",
    "column": "mc7b5ceb67_column",
    "reverse": "mc7b5ceb67_reverse",
    "spacer": "mc7b5ceb67_spacer",
    "row": "mc7b5ceb67_row",
    "pad-1": "mc7b5ceb67_pad-1",
    "wrap": "mc7b5ceb67_wrap",
    "pad-2": "mc7b5ceb67_pad-2",
    "pad-3": "mc7b5ceb67_pad-3",
    "pad-4": "mc7b5ceb67_pad-4",
    "pad-5": "mc7b5ceb67_pad-5",
    "pad-6": "mc7b5ceb67_pad-6",
    "pad-8": "mc7b5ceb67_pad-8",
    "pad-10": "mc7b5ceb67_pad-10",
    "pad-12": "mc7b5ceb67_pad-12",
    "pad-16": "mc7b5ceb67_pad-16",
    "pad-20": "mc7b5ceb67_pad-20",
    "pad-24": "mc7b5ceb67_pad-24",
    "pad-32": "mc7b5ceb67_pad-32",
    "pad-40": "mc7b5ceb67_pad-40",
    "pad-48": "mc7b5ceb67_pad-48",
    "pad-56": "mc7b5ceb67_pad-56",
    "pad-64": "mc7b5ceb67_pad-64"
};

const align = PropTypes.oneOf(['start', 'end', 'flex-start', 'flex-end', 'center', 'stretch', 'baseline', 'first-baseline', 'last-baseline']);
const content = PropTypes.oneOf(['left', 'right', 'flex-start', 'flex-end', 'center', 'baseline', 'first-baseline', 'last-baseline', 'space-between', 'space-around', 'space-evenly']);
const propTypes = {
  as: PropTypes.elementType.isRequired,
  direction: PropTypes.oneOf(['row', 'column']).isRequired,
  pad: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  wrap: PropTypes.bool,
  grow: PropTypes.bool,
  inline: PropTypes.bool,
  flex: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  align: align.isRequired,
  alignSelf: align,
  alignContent: content,
  justify: content.isRequired
};
const defaultProps = {
  as: 'div',
  direction: 'row',
  align: 'stretch',
  justify: 'flex-start'
};

const Block = React.forwardRef((_ref, ref) => {
  let {
    as: Component,
    grow,
    inline,
    flex,
    alignSelf,
    className,
    style
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "direction", "reverse", "pad", "wrap", "grow", "inline", "flex", "align", "alignSelf", "alignContent", "justify", "className", "style"]);

  let flexValue = flex === true ? '1' : flex;

  if (grow && flexValue == null) {
    flexValue = '1 0 auto';
  }

  return React.createElement(Component, Object.assign({}, props, {
    ref: ref,
    style: _extends({}, style, {
      '--fcl-d': inline ? 'inline-block' : 'block',
      '--fcl-as': alignSelf || 'initial',
      '--fcl-f': flexValue || 'initial'
    }),
    className: classNames(className, styles.layout)
  }));
});
Block.displayName = 'Block';
Block.propTypes = propTypes;
Block.defaultProps = defaultProps;
const Flex = React.forwardRef((_ref2, ref) => {
  let {
    as: Component,
    direction,
    reverse,
    pad,
    wrap,
    grow,
    inline,
    flex,
    align,
    alignSelf,
    alignContent,
    justify,
    className,
    style
  } = _ref2,
      props = _objectWithoutPropertiesLoose(_ref2, ["as", "direction", "reverse", "pad", "wrap", "grow", "inline", "flex", "align", "alignSelf", "alignContent", "justify", "className", "style"]);

  let flexValue = flex === true ? '1' : flex;

  if (grow && flexValue == null) {
    flexValue = '1';
  }

  return React.createElement(Component, Object.assign({}, props, {
    ref: ref,
    style: _extends({}, style, {
      '--fcl-d': inline ? 'inline-flex' : 'flex',
      '--fcl-a': align || 'initial',
      '--fcl-ac': alignContent || 'initial',
      '--fcl-as': alignSelf || 'initial',
      '--fcl-jc': justify || 'initial',
      '--fcl-w': wrap ? 'wrap' : 'initial',
      '--fcl-f': flexValue || 'initial'
    }),
    className: classNames(className, styles.layout, direction && styles[direction], reverse && styles.reverse, pad != null && styles[`pad-${pad === true ? '3' : pad}`], wrap && styles.wrap)
  }), props.children);
});
Flex.displayName = 'Flex';
Flex.propTypes = propTypes;
Flex.defaultProps = defaultProps;
const Layout = React.forwardRef((_ref3, ref) => {
  let {
    display
  } = _ref3,
      props = _objectWithoutPropertiesLoose(_ref3, ["display"]);

  if (display === 'block') return Block.render(props, ref);
  return Flex.render(props, ref);
});
Layout.displayName = 'Layout';
Layout.propTypes = _extends({}, propTypes, {
  display: PropTypes.oneOf(['flex', 'block'])
});
Layout.defaultProps = defaultProps;
Layout.Flex = Flex;
Layout.Block = Block;

Layout.Spacer = () => React.createElement("div", {
  className: styles.spacer
});

export default Layout;
